export default {
  title: 'Zarządzaj swoim biznesem z dowolnego miejsca',
  description: 'Zaloguj się na swoje konto.',
  form: {
    email: {
      label: 'E-mail',
      placeholder: 'Wprowadź e-mail',
    },
    password: {
      label: 'Hasło',
      placeholder: 'Wprowadź hasło',
    },
    error_messages: {
      missing_info: 'Brakujące informacje',
      wrong_credentials: 'Nieprawidłowy e-mail lub hasło',
    },
  },
  buttons: {
    login: 'Zaloguj się',
    forgot_password: 'Nie pamiętam hasła',
  },
  white_label: {
    title: 'Zaloguj się do panelu',
    form: {
      email: {
        label: 'Adres e-mail',
        placeholder: 'ty@restauracja.com',
      },
      password: {
        label: 'Hasło',
        placeholder: 'Wprowadź hasło',
      },
    },
    buttons: {
      login: 'Zaloguj się',
    },
    intro: {
      eyebrow: 'Zarządzanie zamówieniami',
      headline: 'Zarządzaj restauracją z dowolnego miejsca.',
      description: 'Zamówienia, menu, godziny otwarcia i wypłaty — wszystko w jednym miejscu.',
      features: {
        live: {
          title: 'Na żywo',
          subtitle: 'śledzenie zamówień',
        },
        instant: {
          title: 'Natychmiastowe',
          subtitle: 'zmiany w menu',
        },
        any_device: {
          title: 'Każde urządzenie',
          subtitle: 'telefon lub tablet',
        },
      },
    },
  },
};
